import { BellOff, BellRing } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { useBrowserNotifications } from '../push/useBrowserNotifications'

/**
 * Turns system notifications on for this browser. Hidden when the build has no Firebase config
 * (nothing to turn on) and in the Android app, which has its own push. The permission prompt
 * appears only after the click.
 */
export function BrowserNotificationsToggle({ className }: { className?: string }) {
  const { state, busy, enable, disable } = useBrowserNotifications()

  if (state === 'unconfigured') return null

  if (state === 'unsupported') {
    return <p className={className}>Browser notifications are not supported here.</p>
  }
  if (state === 'blocked') {
    return (
      <p className={className}>
        <BellOff className="mr-1 inline h-3.5 w-3.5" aria-hidden="true" />
        Browser notifications are blocked. Allow them in your browser's site settings.
      </p>
    )
  }
  return state === 'on' ? (
    <div className={className}>
      <span className="mr-2 inline-flex items-center gap-1 text-xs text-muted-foreground">
        <BellRing className="h-3.5 w-3.5" aria-hidden="true" /> Browser notifications are on
      </span>
      <Button type="button" variant="ghost" size="sm" disabled={busy} onClick={() => void disable()}>
        Turn off
      </Button>
    </div>
  ) : (
    <div className={className}>
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => void enable()}>
        <BellRing className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
        Enable browser notifications
      </Button>
    </div>
  )
}
